import React, { useState } from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogDescription, 
  DialogFooter, 
  DialogHeader, 
  DialogTitle 
} from '@/components/UI/dialog';
import { Button } from '@/components/UI/button';
import { Textarea } from '@/components/UI/textarea';
import { Loader2, AlertTriangle } from 'lucide-react';

const PHOENICIAN_GOLD = '#A2732E';

const ApprovalDialog = ({ open, onClose, onSubmit, month, loading }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  
  const formatMonth = (monthStr) => {
    if (!monthStr) return '';
    try {
      const [year, monthNum] = monthStr.split('-');
      const date = new Date(parseInt(year), parseInt(monthNum) - 1, 1);
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June', 
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
    } catch (e) {
      return monthStr;
    }
  };
  
  const handleSubmit = () => {
    if (!reason.trim()) {
      setError('Please provide a reason for your request');
      return;
    }
    
    if (reason.trim().length < 10) {
      setError('Please provide a more detailed explanation');
      return;
    }
    
    setError('');
    onSubmit(reason);
  };
  
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <AlertTriangle className="h-5 w-5 mr-2 text-amber-500" />
            Approval Required
          </DialogTitle>
          <DialogDescription>
            You need approval to upload a certificate for {formatMonth(month)} without having the previous month's certificate.
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-sm text-slate-700 mb-2">
            Please explain why you need to upload this certificate without having the previous month's certificate:
          </p>
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Example: Previous month certificate was lost. The project started this month and doesn't have a previous certificate."
            className="min-h-[120px]"
          />
          {error && (
            <p className="text-sm text-red-600 mt-2">{error}</p>
          )}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={loading}
            style={{ backgroundColor: PHOENICIAN_GOLD }}
          >
            {loading ? (
              <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Submitting...</>
            ) : (
              'Request Approval'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ApprovalDialog;